import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVentCover = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 20,
	viewBox: "0 0 10.0 20.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 5.0 3.0 L 0.0 13.0 L 10.0 13.0 Z M 5.0 20.0 L 5.0 13.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 5.0 L 5.0 0.0 L 10.0 5.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgVentCover;
